'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _auth = require('../actions/auth');

var _login_form = require('../components/login_form');

var _login_form2 = _interopRequireDefault(_login_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignIn = _react2.default.createClass({
    displayName: 'SignIn',

    propTypes: {
        auth: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillMount: function componentWillMount() {
        var auth = this.props.auth;

        if (auth.email && auth.password) {
            if (auth.exp > Date.now()) {
                // 自动登录
                this.props.dispatch((0, _auth.requestLoginIfNeeded)(auth));
            }
        }
    },
    componentDidUpdate: function componentDidUpdate() {
        var auth = this.props.auth;
        var token = auth.token;

        if (token) {
            this.props.router.push('/');
        }
    },
    onLogin: function onLogin(profile) {
        this.props.dispatch((0, _auth.requestLoginIfNeeded)(profile));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'sign-in' },
            _react2.default.createElement(_login_form2.default, { onLogin: this.onLogin })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var auth = store.auth;
    return {
        auth: auth
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(SignIn));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/signin.js
// module id = 1563
// module chunks = 0